/**
 * Find a menu product by its ID across all categories and subcategories.
 */
export const findMenuProductById = (categories, productId) => {
  for (const category of categories ?? []) {
    for (const subCategory of category.subCategories ?? []) {
      const product = subCategory.subProducts?.find(p => p.id === productId);
      if (product) return { product, categoryName: category.name, subCategoryName: subCategory.name };
    }
  }
  return null;
};

/**
 * Resolve upsell config references to actual menu product data,
 * filtering out products not found in the current menu.
 */
export const resolveUpsellProducts = (upsellConfig, categories) => {
  if (!upsellConfig) return { upgrades: [], addOns: [], upgradeLabel: '', addOnLabel: '' };

  const upgrades = (upsellConfig.upgrades ?? [])
    .map(ref => {
      const found = findMenuProductById(categories, ref.productId);
      if (!found) return null;
      return { ...found.product, order: ref.order, categoryName: found.categoryName, subCategoryName: found.subCategoryName };
    })
    .filter(Boolean)
    .sort((a, b) => a.order - b.order);

  const addOns = (upsellConfig.addOns ?? [])
    .map(ref => {
      const found = findMenuProductById(categories, ref.productId);
      if (!found) return null;
      return { ...found.product, order: ref.order, categoryName: found.categoryName, subCategoryName: found.subCategoryName };
    })
    .filter(Boolean)
    .sort((a, b) => a.order - b.order);

  return {
    upgrades,
    addOns,
    upgradeLabel: upsellConfig.upgradeLabel || 'Fancy a twist on your order?',
    addOnLabel: upsellConfig.addOnLabel || 'Want to add anything?',
  };
};

/**
 * Group add-on products by their subcategory name.
 */
export const groupAddOnsBySubCategory = (addOns) => {
  const groups = {};
  for (const item of addOns) {
    const key = item.subCategoryName || 'Other';
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  }
  return groups;
};
